module.exports = __webpack_public_path__ + "files/surveillance.f1206a2b77169f0f7521254b94d08c49.pdf";